'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _react = require('react');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _react2 = _interopRequireDefault(_react);

var _svgResources = require('./svg-resources');

function SvgComponent(resourceKey, className) {
  var resourceStr = (0, _svgResources.getResource)(resourceKey);
  var classNameVal = className ? ' ' + className : '';
  return _react2.default.createElement('span', {
    className: 'svg-resource' + classNameVal,
    dangerouslySetInnerHTML: { __html: resourceStr }
  });
}

exports.SvgComponent = SvgComponent;
